// extracted by mini-css-extract-plugin
module.exports = {"anchor":"_1LOm4"};